import { render, staticRenderFns } from "./StretchedLink.vue?vue&type=template&id=4b689fba&scoped=true&"
import script from "./StretchedLink.vue?vue&type=script&lang=js&"
export * from "./StretchedLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b689fba",
  null
  
)

export default component.exports